import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/spotify': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c136.9 0 248 111.1 248 248s-111.1 248-248 248-248-111.1-248-248 111.1-248 248-248zM348.7 372.9c8.1 0 15.2-6.3 15.2-15.4s-3.6-12.6-9.7-16.5c-71.4-42.7-155.1-44.3-237-26.2-7.5 1.6-13.6 6.5-13.6 16.8 0 8.1 6.1 15.8 15.8 15.8 2.9 0 8-1.6 11.9-2.6 71.7-14.7 144.3-13.1 206.7 24.5 3.9 2.3 6.5 3.6 10.7 3.6zM375.6 307.3c10.9 0 19.3-8.7 19.4-19.5 0-8.7-3.2-14.9-11.3-19.7-49.4-29.4-112.1-45.5-177-45.5-41.6 0-70 5.8-97.8 13.6-10.3 2.9-15.5 10-15.5 20.7 0 10.7 8.7 19.4 19.4 19.4 4.5 0 7.1-1.3 11.9-2.6 82.9-22.5 176.1-7.6 238.6 29.4 3.6 1.9 7.1 4.2 12.3 4.2zM406.6 231.1c12.2 0 23.2-9.7 23.2-23.3 0-11.9-5.1-18.1-12.9-22.6-55.9-32.6-132.4-47.8-205.4-47.8-42.9 0-82.3 4.9-117.5 15.2-9 2.6-17.4 10.3-17.4 23.9 0 13.3 10.1 23.6 23.3 23.6 4.8 0 9.3-1.6 12.9-2.6 82.4-23 209.7-12.8 280.9 29.7 4.5 2.6 7.7 3.9 12.9 3.9z'
      }
    ]
  }
})
